<template>
  <v-row justify="center" class="ma-0">
    <v-col cols="12" class="pa-0">
      <v-toolbar height="60" dark :color="myItem.color">
        <v-toolbar-title class="white--text pl-2">{{ myItem.name ? myItem.name : '新規作成' }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card flat>
        <v-card-text class="overflow-y-auto" :style="dialogHeight">
          <v-row align="center" class="ma-0">
            <v-col cols="12" class="pa-0 b-B">
              <v-toolbar flat color="transparent" height="40">
                <v-toolbar-title class="text-left subheading">
                  <span class="title">基本情報</span>
                </v-toolbar-title>
              </v-toolbar>
            </v-col>
            <v-col cols="12" class="pa-0">
              <v-row class="ma-0 pa-0" align="center">
                <v-col cols="6">
                  <v-row class="ma-0 pa-0" align="center">
                    <v-col cols="1" class="pa-0"></v-col>
                    <v-col cols="3" class="pa-0">
                      <v-avatar-selector
                        v-model="file"
                        :previewSize="80"
                        :tile="false"
                        :url="getProfileImage()"
                        :enable="type != 'view'"
                        :icon="'mdi-image-plus'"
                      >
                      </v-avatar-selector>
                    </v-col>
                    <v-col class="pa-0">
                      <v-btn v-if="!checkAvatar()" dark rounded depressed x-small color="error" @click="onAvatarReset()">
                        <span class="px-1 text-none">初期化</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    ref="school"
                    label="名称"
                    v-model="myItem.name"
                    :rules="[rules.required]"
                    :disabled="type == 'view'"
                    class="title"
                    @change="modified = true"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-row class="ma-0" align="center">
              <v-col cols="6" class="pa-0">
                <v-row v-if="item.classroom" class="ma-0 pa-0" align="center">
                  <v-col cols="6" class="pa-0">
                    <v-text-field
                      ref="zip"
                      v-model="myItem.zip"
                      label="郵便番号"
                      hideDetails
                      append-outer-icon="search"
                      type="text"
                      @click:append-outer="onSearch()"
                      @keyup.enter.native="onSearch()"
                      :disabled="type == 'view'"
                      @change="modified = true"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <v-text-field
                      ref="address"
                      v-model="myItem.address"
                      label="住所"
                      hideDetails
                      :disabled="type == 'view'"
                      @change="modified = true"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <v-text-field
                      ref="address2"
                      v-model="myItem.address2"
                      label="住所（番地・建屋名称・部屋番号）"
                      hideDetails
                      :disabled="type == 'view'"
                      @change="modified = true"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <v-text-field
                      ref="fixed"
                      prepend-icon="mdi-phone-classic"
                      v-model="myItem.phone"
                      label="電話"
                      hideDetails
                      :disabled="type == 'view'"
                      @change="modified = true"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <v-text-field
                      ref="email"
                      prepend-icon="mdi-email"
                      v-model="myItem.email"
                      :rules="[rules.email]"
                      label="Email"
                      hideDetails
                      :disabled="type == 'view'"
                      @change="modified = true"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <v-text-field
                      ref="web"
                      prepend-icon="mdi-web"
                      v-model="myItem.web"
                      :rules="[rules.url]"
                      label="HP"
                      :disabled="type == 'view'"
                      @change="modified = true"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6" class="pa-0" align="center">
                <v-color-picker show-swatches hide-canvas hide-mode-switch hide-inputs swatches-max-height="230px" :swatches="swatches" v-model="myItem.color"></v-color-picker>
              </v-col>
            </v-row>

            <template v-if="this.getPrivilegesLevel(this.data) <= 1">
              <v-col cols="12" class="pa-0 b-B">
                <v-toolbar flat color="transparent" height="40">
                  <v-toolbar-title class="text-left subheading">
                    <span class="title">機能</span>
                  </v-toolbar-title>
                </v-toolbar>
              </v-col>
              <v-col v-if="this.getPrivilegesLevel(this.data) == 0" cols="12" class="pa-0">
                <v-row class="ma-0 pa-0" align="center">
                  <v-col cols="1" class="pa-0"></v-col>
                  <v-col cols="9" class="pa-0">
                    <span>属性</span><span class="primary--text font-weight-bold">{{ myItem.classroom ? ' 教室' : ' グループ' }}</span>
                  </v-col>
                  <v-col cols="2" class="pa-0">
                    <v-switch
                      v-model="myItem.classroom"
                      color="primary"
                      disabled
                      @change="modified = true"
                      hide-details
                      class="my-2"
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-col>
              <v-col v-if="!item.classroom" cols="12" class="pa-0">
                <v-row class="ma-0 pa-0" align="center">
                  <v-col cols="1" class="pa-0"></v-col>
                  <v-col cols="9" class="pa-0">
                    <span>タスク管理機能</span><span class="primary--text font-weight-bold">{{ myItem.task ? ' 有効' : ' 無効' }}</span>
                  </v-col>
                  <v-col cols="2" class="pa-0">
                    <v-switch
                      v-model="myItem.task"
                      color="primary"
                      :disabled="type == 'view'"
                      @change="modified = true"
                      hide-details
                      class="my-2"
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="pa-0">
                <v-row class="ma-0 pa-0" align="center">
                  <v-col cols="1" class="pa-0"></v-col>
                  <v-col cols="9" class="pa-0">
                    <span>伝言</span><span class="primary--text font-weight-bold">{{ myItem.public ? ' 公開' : ' 非公開' }}</span>
                  </v-col>
                  <v-col cols="2" class="pa-0">
                    <v-switch
                      v-model="myItem.public"
                      color="primary"
                      :disabled="type == 'view'"
                      @change="modified = true"
                      hide-details
                      class="my-2"
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-col>
              <v-col v-if="!myItem.classroom" cols="12" class="pa-0">
                <v-row class="ma-0 pa-0" align="center">
                  <v-col cols="1" class="pa-0"></v-col>
                  <v-col cols="9" class="pa-0">
                    <span>伝言（他塾）</span><span class="error--text font-weight-bold">{{ myItem.chatsShare ? ' 公開' : ' 非公開' }}</span>
                  </v-col>
                  <v-col cols="2" class="pa-0">
                    <v-switch
                      v-model="myItem.chatsShare"
                      color="error"
                      :disabled="type == 'view'"
                      @change="modified = true"
                      hide-details
                      class="my-2"
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="pa-0">
                <v-row class="ma-0 pa-0" align="center">
                  <v-col cols="1" class="pa-0"></v-col>
                  <v-col cols="9" class="pa-0">
                    <span class="red--text">グループ</span><span class="red--text font-weight-bold">{{ myItem.enable ? ' 有効' : ' 無効' }}</span>
                  </v-col>
                  <v-col cols="2" class="pa-0">
                    <v-switch
                      v-model="myItem.enable"
                      color="error"
                      :disabled="type == 'view'"
                      @change="modified = true"
                      hide-details
                      class="my-2"
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-col>
            </template>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded depressed @click="onClose()">取消</v-btn>
          <v-btn v-if="type != 'view'" rounded depressed color="primary" @click.native="updateDialog = true">{{ myItem && myItem.key != null ? '更新' : '登録' }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        title='更新'
        message='更新します。よろしいですか？'
        :dialog='updateDialog'
        color="error"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-row>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      windowSize: 'shared/windowSize'
    }),
    swatches () {
      return [
        ['#F44336', '#E91E63', '#9C27B0'],
        ['#673AB7', '#3F51B5', '#2196F3'],
        ['#03A9F4', '#00BCD4', '#009688'],
        ['#4CAF50', '#8BC34A', '#CDDC39'],
        ['#FFEB3B', '#FFC107', '#FF9800'],
        ['#FF5722', '#795548', '#607D8B'],
        ['#9E9E9E', '#616161', '#000000']
      ]
    },
    dialogHeight () {
      var h = Math.round(this.windowSize.y * 0.6)
      h = h > 700 ? 700 : h
      return 'height: ' + String(h) + 'px;'
    }
  },
  data () {
    return {
      modified: false,
      updateDialog: false,
      loading: false,
      file: null,
      url: null,
      userList: {},
      rules: {
        required: value => !!value || 'Required.',
        email: value => {
          if (value) {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          }
          return false
        },
        url: value => {
          if (value) {
            // eslint-disable-next-line
            const pattern = /^(ftp|http|https):\/\/(([a-zA-Z0-9$\-_.+!*'(),;:&=]|%[0-9a-fA-F]{2})+@)?(((25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9]|[1-9][0-9]|[0-9])(\.(25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9]|[1-9][0-9]|[0-9])){3})|localhost|([a-zA-Z0-9\-\u00C0-\u017F]+\.)+([a-zA-Z]{2,}))(:[0-9]+)?(\/(([a-zA-Z0-9$\-_.+!*'(),;:@&=]|%[0-9a-fA-F]{2})*(\/([a-zA-Z0-9$\-_.+!*'(),;:@&=]|%[0-9a-fA-F]{2})*)*)?(\?([a-zA-Z0-9$\-_.+!*'(),;:@&=\/?]|%[0-9a-fA-F]{2})*)?(\#([a-zA-Z0-9$\-_.+!*'(),;:@&=\/?]|%[0-9a-fA-F]{2})*)?)?$/
            return pattern.test(value) || 'Invalid URL.'
          }
          return false
        }
      }
    }
  },
  props: [ 'item', 'dialog', 'type', 'school' ],
  created () {
    this.myItem = this.item
    if (typeof this.myItem.chatsShare === 'undefined') {
      Vue.set(this.myItem, 'chatsShare', false)
    }
    if (typeof this.myItem.color === 'undefined') {
      this.myItem['color'] = '#1976D2FF'
    }
    if (typeof this.myItem.task === 'undefined') {
      Vue.set(this.myItem, 'task', false)
    }
  },
  watch: {
    file () {
      this.modified = true
    }
  },
  methods: {
    checkGroup (myItem) {
      if (this.myItem === null) {
        return true
      }
      return myItem.groups[this.myItem.key]
    },
    checkEditable (myItem) {
      return myItem.key !== null
    },
    getName (myItem) {
      var name = ''
      if (myItem.sei) {
        name += myItem.sei
      }
      if (myItem.mei) {
        name += myItem.mei
      }
      if (name === '') {
        name = myItem.email
      }
      return name
    },
    getProfileImage () {
      if (this.myItem) {
        if (this.myItem.avatar) {
          return this.myItem.avatar.thumbnail
        }
      }
      return ''
    },
    checkAvatar () {
      if (this.getPrivilegesLevel(this.data) <= 1) {
        return false
      }
      if (this.myItem.avatar) {
        return this.myItem.avatar.path
      }
      return true
    },
    onSelect (myItem) {
      this.file = null
      this.myItem = JSON.parse(JSON.stringify(myItem))
      this.modified = false
    },
    onAvatarReset () {
      this.file = null
      this.myItem.avatar = null
      this.modified = true
    },
    onClose () {
      this.$emit('dismissed')
    },
    onAdd () {
      this.myItem = JSON.parse(JSON.stringify(this.$store.getters['groups/initial']))
      var v = {}
      v[this.school.key] = true
      this.myItem.schools = v
      this.myItem.createdAt = parseInt(new Date().getTime())
      this.modified = true
      this.file = null
    },
    onGroupSelect (myItem) {
      this.myItem = JSON.parse(JSON.stringify(myItem))
      this.file = null
      this.createUsers()
    },
    onUpdate () {
      var vm = this
      var payload = null
      var index = this.groups.findIndex(g => g.key === this.myItem.key)
      if (index === -1) {
        payload = JSON.parse(JSON.stringify(this.$store.getters['groups/initial']))
      } else {
        payload = JSON.parse(JSON.stringify(this.groups[index]))
      }
      if (this.$refs.school.validate(true)) {
        vm.loading = true
        var keys = Object.keys(this.$store.getters['groups/initial'])
        for (var i in keys) {
          payload[keys[i]] = JSON.parse(JSON.stringify(this.myItem[keys[i]]))
        }
        if (payload.key === null) {
          payload.schools[this.school.key] = true
        }
        payload['updatedAt'] = parseInt(new Date().getTime())
        this.$store.dispatch('groups/write', JSON.parse(JSON.stringify(payload))).then((resp) => {
          if (vm.file) {
            vm.$store.dispatch('storage/write', { blob: vm.file, child: 'groups', id: resp, uuid: this.genUUIDv4() }).then(() => {
              if (vm.dialog) {
                vm.$emit('dismissed')
              }
              vm.modified = false
              vm.loading = false
            })
          } else {
            if (vm.dialog) {
              vm.$emit('dismissed')
            }
            vm.modified = false
            vm.loading = false
          }
        })
      }
    },
    onSearch () {
      var vm = this
      if (this.myItem.zip === '' || this.myItem.zip.length < 7) {
        return
      }
      this.loading = true
      var payload = this.myItem.zip
      this.$store.dispatch('postcode/search', payload).then(function (data) {
        if (data) {
          vm.myItem.address = data.val().a7
        } else {
          vm.myItem.address = null
          vm.myItem.address2 = null
        }
        vm.loading = false
      })
    },
    onRefresh () {
      this.file = null
      this.myItem = JSON.parse(JSON.stringify(this.item))
      this.modified = false
    },
    onDismissed: function (result) {
      this.updateDialog = false
      if (result) {
        this.$nextTick(function () {
          this.onUpdate()
        })
      }
    }
  }
}
</script>

<style scoped>
 .overflow-text-hidden {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: block !important;
  user-select: none !important;
}

.b-B-GREY {
  border-bottom: 1px solid #EEEEEE80 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-B-GREY-DARK {
  border-bottom: 1px solid grey !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-B {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.customHeader {
  cursor: pointer;
  user-select: none;
}

.customLine {
  cursor: pointer;
  user-select: none;
}

.customLine:hover {
  background-color: #CCCCCC20;
}
</style>
